<template>
  <div class="column">
    <div class="mb-5 col-4">
      <label>
        {{$t('CONTENT.assets.liquidation_value')}}:
        <span class="b-form__required">*</span>
      </label>
      <numeric class="b-numeric" controls :min="0" :max="1000000000000" v-model="newLiquidationValue"></numeric>
    </div>
  </div>
</template>

<script>

import ChangeLiquidationValue from "../../models/commands/ChangeLiquidationValue";
import dateConverter from "@/utils/converters/date.converter";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  props: {
    assetComponent: {
      type: Object,
      required: true
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      newLiquidationValue: null
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.newLiquidationValue = this.assetComponent.liquidationValue;
    },

    cancel() {
      this.init();
    },

    save() {
      const command = new ChangeLiquidationValue(
        this.assetComponent.idInDB,
        this.newLiquidationValue,
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>
<style>
</style>
